import { render, staticRenderFns } from "./QuestionnaireFormatPageEditor.vue?vue&type=template&id=774a6999&scoped=true&"
import script from "./QuestionnaireFormatPageEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFormatPageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFormatPageEditor.vue?vue&type=style&index=0&id=774a6999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a6999",
  null
  
)

export default component.exports